import React from 'react';
import './sectionOneDetails.css';

const SectionOneDetails = ({ choose }) => {
     const { img, post, title } = choose;
     return (
          <div>
               <div className='section-details'>
                    <img src={img} alt="" />
                    <h6 className='fw-bold'>{title}</h6>
                    <p>{post}</p>
               </div>

          </div>
     );
};

export default SectionOneDetails;